<backoffice-app-fe-spinner></backoffice-app-fe-spinner>
<section class="backoffice">
    <backoffice-app-fe-header class="backoffice--header"></backoffice-app-fe-header>
    <backoffice-app-fe-sidebar class="backoffice--sidebar"></backoffice-app-fe-sidebar>
    <div class="backoffice--main">
        <router-outlet></router-outlet>
    </div>
</section>
